import * as yup from 'yup';

export const formSchema = yup.object({
    startDate: yup.date().required(),
    endDate: yup.mixed().optional(),
    company: yup.string().required(),
    contract_type: yup.string().required(),
    contract: yup.mixed().optional(),
});
